import React, { useState, useEffect, useRef } from "react";
import Logo from '../assets/logo.png';
import { Link } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoIosClose } from "react-icons/io";
import { useNavigate, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // to go to the feature section on homepage
  const handleFeatureClick = () => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home with the #feature anchor
      navigate('/#feature');
    } else {
      // If already on home page, scroll to the section
      const featureElement = document.getElementById('feature');
      if (featureElement) {
        featureElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };

  // to go to the signup section
  const handleSignupClick = () => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home with the #feature anchor
      navigate('/#signup');
    } else {
      // If already on home page, scroll to the section
      const signupElement = document.getElementById('signup');
      if (signupElement) {
        signupElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMenuOpen(false);
  };



  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      closeMenu();
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);

    // Show the navbar with a delay for smooth transition
    setTimeout(() => {
      setIsNavVisible(true);
    }, 100);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
    {isScrolled && <div className="h-20"></div>}
      <nav
        className={`w-full top-0 left-0 z-50 transition-all duration-1000 ease-in-out transform ${isScrolled ? 'fixed bg-white bg-opacity-5 backdrop-blur-lg' : 'relative bg-navy'
          } ${isNavVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}
      >
        <div className="lg:container mx-auto my-auto py-auto flex items-center justify-between">
          <Link to="/" className="">
            <img
              className="w-28 h-auto"
              src={Logo}
              alt="Logo"
            />
          </Link>

          <div className="hidden md:flex space-x-6 lg:ml-40">
            <Link to="/" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"></Link>
            <button onClick={handleFeatureClick} className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"></button>
            <Link to="#" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"></Link>
           
            {/* <Link to="#" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100">Telegram Access</Link> */}
          </div>

          <div className="hidden md:flex items-center space-x-5">
            {/* <span className="text-white md:ml-5 font-bold md:hidden lg:flex">App Coming Soon!</span> */}

<a href="https://www.papermark.com/view/cmhj5w7da0009la047bzqng86" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"> Services & Portfolio  </a>

<a href="https://x.com/hussainzulz" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"> Founder  </a>

<Link to="/crypto" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100">ZelFi Analytics</Link>
      

<a href="http://calendly.com/hussainzulfiqar142" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"> Get in touch  </a>


          </div>

       

          <div className="md:hidden mr-5 text-lg">
            <button onClick={toggleMenu} className="text-white text-2xl focus:outline-none">
              {isMenuOpen ? <IoIosClose /> : <RxHamburgerMenu />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          ref={menuRef}
          className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out ${isMenuOpen ? 'max-h-screen backdrop-blur-lg bg-white/20' : 'max-h-0'
            }`}
        >
          <div className="flex flex-col bg-navy px-5 py-4 space-y-4">
            
<a href="https://www.papermark.com/view/cmhj5w7da0009la047bzqng86" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"> Services & Portfolio  </a>

<a href="https://x.com/hussainzulz" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"> Founder  </a>

<Link to="/crypto" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100">ZelFi Analytics</Link>
      

<a href="http://calendly.com/hussainzulfiqar142" className="text-white text-sm whitespace-nowrap uppercase font-bold hover:text-gray-100"> Get in touch  </a>


          </div>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
